var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{staticClass:"mr-3",attrs:{"pill":""}},[_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":'/'}},[_vm._v(" Lecteur ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }